import ModalHoc from '@/components/ModalHoc';
import Button from '@/components/Button';
import modalStyles from '@/components/ModalHoc/styles.module.scss';
import promptStyles from '@/components/ModalHoc/stylesPrompt.module.scss';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

const SharedWidgetSelectConfirmModal = _ref => {
  let {
    widget,
    onConfirm
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: modalStyles.main,
    children: [/*#__PURE__*/_jsxs("header", {
      className: promptStyles.header,
      children: [/*#__PURE__*/_jsxs("h5", {
        className: promptStyles.heading,
        children: ["Use: \"", widget.title, "\""]
      }), /*#__PURE__*/_jsx("p", {
        className: promptStyles.subHeading,
        children: "Leave this page and open this template in the editor."
      })]
    }), /*#__PURE__*/_jsx(Button, {
      size: "large",
      onClick: () => onConfirm(widget),
      className: "-l-fullWidth",
      children: "Choose as Template"
    })]
  });
};

export default ModalHoc(SharedWidgetSelectConfirmModal);